import api from "PFCore/api";
import { ProjectsResponse } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { QueryParams } from "PFTypes";

export type FetchProjectsRolesParams = QueryParams;

export const fetchProjectsRoles = (data: FetchProjectsRolesParams) =>
  api<ProjectsResponse>({
    url: `booking_module/roles/index`,
    method: "POST",
    data
  });
